import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
`;

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: ${({ enabled }) =>
    enabled ? 'var(--if-diff-add-bg)' : 'var(--if-diff-remove-bg)'};
  color: ${({ enabled }) =>
    enabled ? 'var(--if-diff-add-ink)' : 'var(--if-diff-remove-ink)'};
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;

const Arrow = styled.span`
  color: var(--if-ink-3);
  font-size: 12px;
`;

export default function BooleanDiff({ from, to }) {
  const fromBool = String(from) === 'true';
  const toBool = String(to) === 'true';

  return (
    <Wrapper>
      <Pill enabled={fromBool}>
        <Dot />
        {fromBool ? 'enabled' : 'disabled'}
      </Pill>
      <Arrow>&rarr;</Arrow>
      <Pill enabled={toBool}>
        <Dot />
        {toBool ? 'enabled' : 'disabled'}
      </Pill>
    </Wrapper>
  );
}

BooleanDiff.propTypes = {
  from: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  to: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};
